export const coachConfig = {
  coachModeId: 'SEARCH_DISCOVERY_MVP_MODE_V1',
  coachActionId: 'TYPED_MESSAGE',
};

export const coachAdditionalContext = {
  contextKey: 'additionalContext.roleData',
  contextValue: 'New Learner',
};
